import React, { useRef } from "react";
import { Grid, Box } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import { InputField } from "../textBox/InputField";
import FormLabels from "../../../library/custom/formLabel/FormLabels";
import "./Section.scss";
import Buttons from "../button/Button";
import FormDropZone from "../../../library/dropZone/FormDropZone";
import ImageUploader from "../../../library/custom/media/ImageEditor ";
import TextEditor from "../textEditor/TextEditor";
import Tooltip from "@mui/material/Tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export default function Section(props) {
  const {
    singleSection,
    keyNo,
    handleOnChangeSectionForm,
    sectionImageUpload,
    isErrorSectionName = false,
    id,
    cancelSectionList,
    deleteImageURL,
    sectionFileUploads,
    deleteUrlURL,
    isCloneOf,
    lessonName,
    errors,
  } = props;
  const editor = useRef(null);
  const disabl = isCloneOf && singleSection.videoLink ? true : false;
  return (
    <>
      <div className="overideSection" key={keyNo}>
        <div className="sectionBox">
          <h1 className="title">{`Section${keyNo}`}</h1>
          <Grid item container mt={3}>
            <Grid lg={12} xs={12} sm={12} md={12}>
              <ImageUploader
                key={singleSection.id}
                handleFileChange={(filesPath, fileDataId) =>
                  sectionImageUpload(filesPath, fileDataId)
                }
                imageUrl={
                  singleSection.imgFilesUrl ? singleSection.imgFilesUrl : []
                }
              />
            </Grid>
          </Grid>
          <Grid item container mt={1} spacing={2}>
            <Grid item lg={12} xs={12} sm={12} md={8}>
              <FormControl fullWidth>
                <FormLabels label="Add  Text" />
                <TextEditor
                  value={singleSection.Text}
                  onChange={(content) => {
                    handleOnChangeSectionForm(content, singleSection, "Text");
                  }}
                />
              </FormControl>
            </Grid>
          </Grid>

          <Grid item container mt={1} spacing={2}>
            <Grid item lg={12} xs={12} sm={12} md={6}>
              <FormControl fullWidth>
                <Box display="flex" alignItems="center" gap="1px">
                  <FormLabels label="Embed Video Link" isRequired={false} />
                  <Tooltip
                    title={
                      <div className="tooltip-main">
                        <div style={{ marginBottom: "6px", fontWeight: 600 }}>
                          When adding the Embed Video Link, only include the
                          link that is between the “two quotation marks”.
                        </div>

                        <div className="iframeSectionmain-heading">
                          {" "}
                          Example:
                        </div>
                        <div className="iframeSectionmain-heading">
                          YouTube:
                        </div>

                        <div className="iframeSectionmain">
                          &lt;iframe &nbsp;&nbsp;width="1122"
                          &nbsp;&nbsp;height="505" &nbsp;src="
                          <span className="green-link">
                            https://www.youtube.com/embed/4BzjUq921Y4
                          </span>
                          "<br />
                          &nbsp;&nbsp;title="The Power and Beauty of
                          Construction Sites: A Cinematic Reel"
                          &nbsp;&nbsp;frameborder="0"
                          &nbsp;&nbsp;allow="accelerometer; autoplay;
                          clipboard-write; encrypted-media; gyroscope;
                          picture-in-picture; web-share"
                          &nbsp;&nbsp;referrerpolicy="strict-origin-when-cross-origin"
                          &nbsp;&nbsp;allowfullscreen&gt; &lt;/iframe&gt;
                        </div>

                        <div className="iframeSectionmain-heading">Vimeo:</div>

                        <div className="iframeSectionmain">
                          &lt;iframe &nbsp;&nbsp;width="1122"
                          &nbsp;&nbsp;height="505" &nbsp;src="
                          <span className="green-link">
                            https://player.vimeo.com/video/11690541?badge=0&autopause=0&player_id=0&app_id=8479
                          </span>
                          " &nbsp;&nbsp;frameborder="0"
                          &nbsp;&nbsp;allow="autoplay; fullscreen;
                          picture-in-picture; clipboard-write; encrypted-media;
                          web-share"
                          &nbsp;&nbsp;referrerpolicy="strict-origin-when-cross-origin"
                          &nbsp;&nbsp;title="Title"&gt; &lt;/iframe&gt;
                        </div>
                      </div>
                    }
                    placement="bottom-start"
                    arrow
                    componentsProps={{
                      tooltip: {
                        sx: {
                          backgroundColor: "#ffffff",
                          color: "#333333",
                          fontFamily: "Lato",
                          fontSize: "13px",
                          padding: "8px 12px",
                          borderRadius: "8px",
                          border: "2px solid #ccc",
                          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                        },
                      },
                      arrow: {
                        sx: {
                          color: "#ffffff",
                          "&::before": {
                            borderRadius: "2px",
                            border: "2px solid #ccc",
                          },
                        },
                      },
                    }}
                    PopperProps={{ disablePortal: true }}
                  >
                    <InfoOutlinedIcon
                      fontSize="small"
                      className="infoOut-linedIcon"
                    />
                  </Tooltip>
                </Box>
                <InputField
                  fullWidth={true}
                  type="text"
                  id="embededVideoLink"
                  // label="Embed Video Link"
                  placeholder="Embed Video Link"
                  value={
                    disabl
                      ? lessonName + " " + "Video"
                      : singleSection.embededVideoLink
                  }
                  isError={isErrorSectionName}
                  onChange={(e) =>
                    handleOnChangeSectionForm(
                      e,
                      singleSection,
                      "embededVideoLink",
                    )
                  }
                  disabled={disabl}
                />
              </FormControl>
              {errors && <div className="error">Please add proper link</div>}
            </Grid>
          </Grid>
          <Grid item container mt={4}>
            <Grid lg={12} xs={12} sm={12} md={12}>
              <FormDropZone
                key={singleSection.id}
                label={"Add Document"}
                id="uploadDocs"
                paraText1={"Drop the file here ..."}
                paraText2={"Drop Document here, "}
                paraText3={"or Browse"}
                handleFileChange={(photo, id) => sectionFileUploads(photo, id)}
                imageUrl={
                  singleSection.docFilesUrl ? singleSection.docFilesUrl : []
                }
                deleteImageURL={(url) => deleteUrlURL(url)}
                fileType={10}
                isDynamics={false}
                isMuliple={false}
                isDoc={true}
                isImage={false}
                allFiles={false}
              />
            </Grid>
          </Grid>
        </div>
        <div className="sectionCancel">
          <Grid item container mt={3}>
            <Grid lg={12} xs={12} sm={12} md={12}>
              <Box mb={2} textAlign="right">
                <Buttons
                  variantOutline={true}
                  onClick={() => cancelSectionList(id)}
                  label="Cancel"
                ></Buttons>
              </Box>
            </Grid>
          </Grid>
        </div>
      </div>
    </>
  );
}
